import { AccordionProps } from './interface'

export const Accordion = ({ children }: AccordionProps) => {
	return <section className='border rounded-md overflow-hidden'>{children}</section>
}
